import Box from '@mui/material/Box';
import { useIsMobile } from '@repo/mui-config/hooks';

import { LoanProcessModalHeader } from '@/components/loan-process/loan-process-modal/loan-process-modal-header';
import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';

interface LiberisIframeComponentProps {
  iframeUrl: string | undefined;
  handleCloseButton: () => void;
}

export const LiberisIframeComponent = ({
  iframeUrl,
  handleCloseButton,
}: LiberisIframeComponentProps) => {
  useLoanProcessSetCurrentModalState('AgreementLiberisIframe');

  const isMobile = useIsMobile();

  return (
    <Box
      data-testid="liberis-sign-iframe"
      sx={{
        px: isMobile ? 2 : 4,
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <LoanProcessModalHeader
        closeButton={{ onClick: handleCloseButton }}
        containerSx={{ mb: 4 }}
      />
      <Box sx={{ flex: 1 }}>
        <iframe
          data-testid="liberis-sign-iframe-content"
          height="100%"
          style={{ border: 'none' }}
          src={iframeUrl}
          title="Liberis"
          width="100%"
        />
      </Box>
    </Box>
  );
};
